import { useReverification } from "@clerk/react";
import { api } from "@/lib/api";

// Wraps an API call so a server "reverification required" answer opens Clerk's re-authentication prompt, then retries.
export function useReauthCall(method, url) {
  return useReverification(async (payload) => {
    try {
      return (await api[method](url, payload)).data;
    } catch (e) {
      const d = e.response?.data;
      if (d?.clerk_error?.reason === "reverification-error") return d;
      throw e;
    }
  });
}
